module.exports = __webpack_public_path__ + "static/media/undraw_data_trends_b0wg.57a833b4.svg";